var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestValueItinerary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_1431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1858 23.9625H30.1531V19.5405H28.3843V39.8814H30.1531V38.1126H39.6637L43.2013 25.7312H47.5773L43.4101 41.5671L44.2378 53.1471H39.8158L38.9314 41.6501H2.98212L3.30398 38.1125H11.581V25.731H15.1186V38.1125H24.8469V39.8813H26.6157V19.5405H24.8469V23.9625H2.81405L0 54.9158H55L52.1858 23.9625ZM38.3302 36.3438H30.1531V25.7312H41.3618L38.3302 36.3438ZM45.1956 41.7333L49.407 25.7312H50.5709L53.0631 53.1471H46.0111L45.1956 41.7333ZM24.8469 36.3438H16.8874V25.7312H24.8469V36.3438ZM9.8122 25.7314V36.344H3.46407L4.42889 25.7314H9.8122ZM2.8211 43.4189H37.2935L38.0418 53.1471H1.93689L2.8211 43.4189Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6165 9.81201H24.8477V14.234H26.6165V9.81201Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1516 9.81201H28.3828V14.234H30.1516V9.81201Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6165 2.7372C26.6165 2.24986 27.0135 1.85279 27.5009 1.85279C27.9882 1.85279 28.3853 2.24986 28.3853 2.7372V4.506H30.1541V2.7372C30.1541 1.27446 28.9636 0.0839844 27.5009 0.0839844C26.0381 0.0839844 24.8477 1.27446 24.8477 2.7372V4.506H26.6165V2.7372Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2901 10.6966H15.1172V3.62158H39.2901L44.302 7.1592L39.2901 10.6966Z",
    fill: "#F9BA48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8801 20.4248H15.7072L10.6953 16.8872L15.7072 13.3496H39.8801V20.4248Z",
    fill: "#F9BA48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_1431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestValueItinerary);
export default __webpack_public_path__ + "static/media/best-value-itinerary.0fb01ef1e530d1f09fbbf09eecea33f5.svg";
export { ForwardRef as ReactComponent };